// import Vue from 'vue'
import { apolloClient } from '@/apollo'
import gql from 'graphql-tag'
import Vue from 'vue'

export const createEditTermsConditions = gql`
mutation createEditTermsConditions($terms: [terms_and_conditions_insert_input!]!, $update_columns: [terms_and_conditions_update_column!] = [id, active, country, published, terms, update_date, version]) {
  insert_terms_and_conditions(objects: $terms, on_conflict: {constraint: terminos_y_condiciones_pkey, update_columns: $update_columns}) {
    returning {
      id
    }
  }
}
`

export const createEditSetOtherRecordsActiveFalseTyC = gql`
mutation createEditSetOtherRecordsActiveFalseTyC($terms: [terms_and_conditions_insert_input!]!, $update_columns: [terms_and_conditions_update_column!] = [id, active, country, published, terms, update_date, version], $version: String!, $country: String!) {
  update_terms_and_conditions(where: {version: {_neq: $version}, country: {_eq: $country}, active: {_eq: true}}, _set: {active: false}) {
    returning {
      id
    }
  }
  insert_terms_and_conditions(objects: $terms, on_conflict: {constraint: terminos_y_condiciones_pkey, update_columns: $update_columns}) {
    returning {
      id
    }
  }
}
`

export const getAllTermsConditions = gql`
query getAllTermsConditions {
  terms_and_conditions(order_by: {version: asc}, distinct_on: version) {
    active
    country
    published
    update_date
    version
  }
}
`

export const GET_ACTIVE_TERMS = gql`
query GET_ACTIVE_TERMS($country: String!, $version: String!) {
  activeTerms: terms_and_conditions(where: {country: {_eq: $country}, active: {_eq: true}, version: {_neq: $version}}) {
    id
  }
}
`

export const GET_TERMS_BY_VERSION = gql`
query GET_TERMS_BY_VERSION($version: String!) {
  terms_and_conditions(where: {version: {_eq: $version}}) {
    active
    country
    published
    id
    responsible_user
    update_date
    lang
    version
    terms
  }
}
`

export const GET_ORG_TO_SET_REQUIRED_TERMS = gql`
query GET_ORG_TO_SET_REQUIRED_TERMS($country: String!) {
  catalog(distinct_on: organization_id, where: {organization: {requires_terms_acceptance: {_eq: false}, terms_and_conditions_id: {_is_null: true}, country: {_eq: $country}}}) {
    organization_id
  }
}
`

export const setRequiredTermsToOrg = gql`
mutation setRequiredTermsToOrg($arrayOfOrgIDs: [uuid!]!) {
  update_organization(where: {id: {_in: $arrayOfOrgIDs}}, _set: {requires_terms_acceptance: true}) {
    affected_rows
    returning {
      id
    }
  }
}
`

const termsConditions = {
  namespaced: true,
  state: {
    terminosCondiciones: []
  },
  actions: {
    async createTermsConditions ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: (variables.version == null) ? createEditTermsConditions : createEditSetOtherRecordsActiveFalseTyC,
          variables
        })
        if (response && response.data && response.data) {
          dispatch('fetchAll')
          return response.data
        }
        throw new Error('Error al crear los términos y condiciones')
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },
    async fetchAll ({ state }) {
      try {
        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: getAllTermsConditions
        })
        if (response && response.data && response.data.terms_and_conditions) {
          Vue.set(state, 'terminosCondiciones', response.data.terms_and_conditions)
          return response.data.terms_and_conditions
        }
      } catch (error) {
        console.error(error)
        return error
      }
    },
    async getActiveTerms ({ state }, variables) {
      try {
        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: GET_ACTIVE_TERMS,
          variables
        })
        if (!response || !response.data || !response.data.activeTerms.length) return null
        return response.data.activeTerms.map(({ id }) => id)
      } catch (error) {
        console.error(error)
        return error
      }
    },
    async getTermsByVersion (store, variables) {
      try {
        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: GET_TERMS_BY_VERSION,
          variables
        })
        if (response && response.data) {
          return response.data.terms_and_conditions
        }
        throw new Error('Error en getTermsByVersion, data no existe')
      } catch (error) {
        console.error(error)
        return error
      }
    },
    generateUUID (store) { // Public Domain/MIT
      /* eslint no-bitwise: ["error", { "int32Hint": true }] */
      let d = new Date().getTime()// Timestamp
      let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0// Time in microseconds since page-load or 0 if unsupported
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = Math.random() * 16// random number between 0 and 16
        if (d > 0) { // Use timestamp until depleted
          r = (d + r) % 16 | 0
          d = Math.floor(d / 16)
        } else { // Use microseconds since page-load if supported
          r = (d2 + r) % 16 | 0
          d2 = Math.floor(d2 / 16)
        }
        // eslint-disable-next-line
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
      })
    },
    async getOrgToSetRequiredTerms (store, variables) {
      try {
        const response = await apolloClient.query({
          fetchPolicy: 'network-only',
          query: GET_ORG_TO_SET_REQUIRED_TERMS,
          variables
        })
        if (!response || !response.data || !response.data.catalog) throw new Error('Error en getOrgToSetRequiredTerms')
        return response.data.catalog.map(org => org.organization_id)
      } catch (error) {
        console.error(error)
        throw new Error('Error en getOrgToSetRequiredTerms')
      }
    },
    async updateOrgFlagReqTerms ({ dispatch }, variables) {
      try {
        const response = await apolloClient.mutate({
          mutation: setRequiredTermsToOrg,
          variables
        })
        if (!response || !response.data) throw new Error('Error al actualizar TyC, updateOrgFlagReqTerms')
        return response.data
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },
    async setRequiredTermsToOrg ({ dispatch }, variables) {
      try {
        const res = await dispatch('getOrgToSetRequiredTerms', variables)
        return dispatch('updateOrgFlagReqTerms', { arrayOfOrgIDs: res })
      } catch (error) {
        console.error(error)
        throw new Error('Error en setFlagToOrg')
      }
    }
  },
  mutations: {
  }
}

export default termsConditions



// WEBPACK FOOTER //
// ./src/store/modules/termsConditions.js